import React from "react";
import './Projects.css';

//import CardProject from "../cardProject/CardProject.jsx";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper";
import "swiper/css/pagination";
import { useTranslation } from "react-i18next"; //translator


import foodapp from '../../assets/foodapp.jpeg';
import wallaby from '../../assets/wallaby.jpeg';
import weatherapp from '../../assets/weatherapp.jpeg';
import calculadora from '../../assets/calculadora.jpeg';
import starwars from '../../assets/starwars.jpeg';
import todolist from '../../assets/todolist.jpeg';







const Projects = () => {
  const [t] = useTranslation("global");

  let r2= t("Projects.reviews.2");
  let r3= t("Projects.reviews.3");
  // eslint-disable-next-line
  let r4= t("Projects.reviews.4");
  // eslint-disable-next-line
  let r5= t("Projects.reviews.5");
  let r6= t("Projects.reviews.6");

    const projects = [
        {
          img: wallaby,
          video: "https://www.youtube.com/embed/AWjlDRoseyQ?si=9lxOscpxE9UJjp7R&amp;start=2&autoplay=1&mute=1&rel=0",
          review:"Marketplace NFTs",
          deploy: "",
          github: "https://github.com/sololmos/wallaby-Front",
        },
        {
          img: foodapp,
          video: "https://www.youtube.com/embed/vxum6g9y3HY?si=eJEToyrVlIHDpsaN&amp;start=1&autoplay=1&mute=1&rel=0" ,
          review:r2,
          deploy : "",
          github:"https://github.com/sololmos/PI-Food",
        },
        {
         
          video: "https://www.youtube.com/embed/JDpnpYZPDdM?si=sL2LseQ5OlHK6pPP;start=0&autoplay=1&mute=1&rel=0" ,
          //se pega el enlace hasta ;start... 
          review:"Rick and morty App created with React, Redux and CSS",
          deploy :"https://rickandmorty-wine-xi.vercel.app/",
          github:"https://github.com/sololmos/rickandmortyapp",
        },       
        {
         
          video: "https://www.youtube.com/embed/M9e9fHLdkjQ?si=C_N_uAneMkO9ojZn;start=0&autoplay=1&mute=1&rel=0" ,
          //se pega el enlace hasta ;start... 
          review:"Website for Polibot, haberdashery wholesaler made with wordpress",
          deploy :"https://www.polibot.com.ar/",
          github:"",//  
        }, 
        {
         
          video: "https://www.youtube.com/embed/nlf1mVjJdJ0?si=QhuKQofFA1pi4rCv;start=0&autoplay=1&mute=1&rel=0" ,
          //se pega el enlace hasta ;start... 
          review:"Landing Page created with Vite/React.js, Bootstrap and Framer Motion",
          deploy :"https://domopage.vercel.app/",
          github:"https://github.com/sololmos/domopage",
        },
        {
         
          video: "https://www.youtube.com/embed/0OufFnfb4no?si=4kOcCDGelwqhUAjR&amp;start=0&autoplay=1&mute=1&rel=0" ,
          review:"Website for  Natalia Villegas, created with WordPress",
          deploy : "https://nvillegas.com",
          github:"",
        },
        {
         
          video: "https://www.youtube.com/embed/wBYX4D-1kYk?si=fcbpUIC94KwEoTWo;start=0&autoplay=1&mute=1&rel=0" ,
          //se pega el enlace hasta ;start... 
          review:"StarWars Frontend Challenge created with Next.js and Tailwind ",
          deploy :"https://starwarschallenge-iota.vercel.app/",
          github:"https://github.com/sololmos/starwarschallenge",
        },
        {
         
          video: "https://www.youtube.com/embed/jy5-Wr3Lyio?si=BPI6b5i59ed8jWd4&amp;start=1&autoplay=1&mute=1&rel=0" ,
          review:"Website for  INNCA , using WordPress",
          deploy :"",
          github:"",
        },
        {
          img: weatherapp,
          review:r3,
          deploy:"https://weatherapp-peach-theta.vercel.app/",
          github:"https://github.com/sololmos/weatherapp",
           
        },
        {
          img: starwars,
          review:"Starwars App",
          deploy:"https://starwars-frontend.vercel.app/",
          github:"https://github.com/sololmos/starwars_frontend_challenge",
           
        },
        {
          img: todolist,
          review:"Todolist App",
          deploy:"https://todolist-app-omega-coral.vercel.app/",
          github:"https://github.com/sololmos/todolist",
           
        },
        {
          img: calculadora,
          review: r6,
          deploy:"https://calculadora-orcin-nu.vercel.app/",
          github:"https://github.com/sololmos/calculadora",
        },
      ];


    return(
        <div className="t-wrapper" id="Projects">
        <div className="t-heading">
          <span>{t("Projects.title.1")}</span> 
          <span> {t("Projects.title.2")} </span>
          <span>{t("Projects.title.3")}</span>
        <div className="blur t-blur1" style={{ background: "var(--yellow)" }}></div>
        <div  className="blur t-blur2" style={{ background: "orange" }}></div>
  
        </div>
        <Swiper
          
          // install Swiper modules
          modules={[Pagination]}
          slidesPerView={1}
          pagination={{ clickable: true  } }
        >
          {projects.map((projects, index) => {
            return (
              <SwiperSlide key={index}>
                <div className="testimonial">
                  {projects.video ? (
                      <iframe
                        width="360"
                        height="2000"
                        src={projects.video}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                    ) : (
                      <img src={projects.img} alt="" />
                    )}

                  <span>{projects.review}</span>

                  <div className="botones">

                    {/* <a href={projects.deploy} target="_blank" rel="noopener noreferrer">
                        <button className="p-button">Deploy</button>
                    </a> */}
                      {projects.deploy !== "" && (
                        <a href={projects.deploy} target="_blank" rel="noopener noreferrer">
                          <button className="p-button">Deploy</button>
                        </a>
                      )}

                    {/* <a href={projects.github} target="_blank" rel="noopener noreferrer">                    
                        <button className="p-button">Github</button>
                    </a> */}
                      {projects.github !== "" && (
                          <a href={projects.github} target="_blank" rel="noopener noreferrer">                    
                            <button className="p-button">Github</button>
                          </a>
                        )}



                    

                  </div>


                 
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
};

export default Projects; 